import { Injectable } from '@angular/core';
import { UserProfileDto } from '@buck-e-icp/interfaces';
export const USER_PROFILE_ID_KEY = 'dashboardUserProfileId';

@Injectable({ providedIn: 'root' })
export class LoginService {
    public getUserProfileIdFromStorage() {
        const item = localStorage.getItem(USER_PROFILE_ID_KEY);
        return item;
    }
    public deleteUserProfileIdFromStorage() {
        localStorage.removeItem(USER_PROFILE_ID_KEY);
    }

    public storeUserProfile(userProfile: UserProfileDto) {
        localStorage.setItem(USER_PROFILE_ID_KEY, userProfile.id);
    }
}
